<template>
  <v-card class="mb-4">
    <v-progress-linear class="ma-auto" v-show="loading" :indeterminate="true" />

    <v-toolbar dense>
      <v-toolbar-title>
        Referrals
      </v-toolbar-title>
      <v-spacer />

      <v-btn icon @click="loadReferrals">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="errors.length > 0">
      <v-alert v-for="message in errors" :key="message" type="error">
        {{ message }}
      </v-alert>
    </div>

    <v-card-text v-if="referrals">
      <v-list dense>
        <v-list-group
          v-for="(referredPeople, referralName) in referrals"
          :key="referralName"
        >
          <template v-slot:activator>
            <v-list-item-title>
              {{ referralName }} ({{ referredPeople.length }})
            </v-list-item-title>
          </template>

          <v-list-item
            v-for="person in referredPeople"
            :key="`person-${person.id}`"
            ripple="ripple"
            :to="`/people/${person.id}`"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ person.id }} - {{ person.nickname }} ({{ person.title }}
                {{ person.firstname }} {{ person.surname }})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "ReferralsList",
  data() {
    return {
      referrals: {},
      referralTypeId: null,
      referralTypeName: null,
      errors: [],
      loading: false,
      attemps: 1
    };
  },
  methods: {
    async loadReferrals() {
      if (this.loading || this.attempts > 3) {
        return;
      }
      this.attempts = this.attempts + 1;

      this.loading = true;
      var reqs = [];

      var referralTypes = this.$store.getters.lookup("ReferralTypes");

      if (!referralTypes.length) {
        var self = this;
        this.loading = false;
        setTimeout(() => {
          self.loadReferrals();
        }, 1000);
      }

      for (const referralType of referralTypes) {
        try {
          let response = await this.$http.get("/people", {
            params: {
              filter: { where: { referralid: referralType.valueid } }
            }
          });

          if (response) {
            this.loading = false;
            this.referrals[referralType.value] = [...response.data];
            this.errors = [];
          }
        } catch (e) {
          this.loading = false;
          this.handleError(e);
        }
      }
      this.attempts = 0;
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  created() {
    this.loadReferrals();
  }
};
</script>
